import { type ConnectedProps, connect } from 'react-redux';

import { useRouter } from 'Hooks';

import { GeneralModal, Providers } from 'Components/utility';

import { type RootState } from 'src/reducers';

const mapState = ({ nav: { location, initErrorStatus } }: RootState) => ({
  initErrorStatus,
  location,
});

const connector = connect(mapState);

type Props = ConnectedProps<typeof connector>;

const App = ({ initErrorStatus, location }: Props) => {
  const Component = useRouter({
    location,
    initErrorStatus,
  });

  return (
    <Providers>
      {Component}
      <GeneralModal />
    </Providers>
  );
};

export default connector(App);
